/**
 * GCLID Cookie Management for Dashboard
 * Reads Google Ads click IDs from cookies set by the marketing site
 */

const COOKIE_NAME = '_cp_gclid';

/**
 * Get GCLID from cookie
 * @returns {string|null} GCLID value or null if not found
 */
export function getGclid() {
  if (typeof document === 'undefined') return null;

  const cookies = document.cookie.split('; ');
  const gclidCookie = cookies.find(c => c.startsWith(`${COOKIE_NAME}=`));
  return gclidCookie ? gclidCookie.split('=')[1] : null;
}
